/**
 * UpgradePage - Advanced features promotion
 */
import React from 'react';
import { Sparkles, CheckCircle, Heart, FileText } from 'lucide-react';
import Header from '../components/shared/Header';

const UpgradePage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="py-12 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12">
            <Sparkles className="w-16 h-16 text-stone-900 mx-auto mb-6" />
            <h2 className="text-4xl md:text-5xl font-bold text-stone-900 mb-4">
              Your Certificate is the Beginning
            </h2>
            <p className="text-xl text-stone-600">
              Unlock the advanced MarrsingClause® app experience
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-8">
              <CheckCircle className="w-10 h-10 text-mc-blue-deep mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-stone-900 mb-2">Guided Renewals</h3>
              <p className="text-stone-600">Annual relationship reviews and clause evolution</p>
            </div>
            <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-8">
              <Heart className="w-10 h-10 text-red-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-stone-900 mb-2">Check-In Rituals</h3>
              <p className="text-stone-600">Structured quarterly reflection rhythms</p>
            </div>
            <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-8">
              <FileText className="w-10 h-10 text-blue-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-stone-900 mb-2">Evolution Dashboard</h3>
              <p className="text-stone-600">Track relationship growth over time</p>
            </div>
          </div>

          <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-12">
            <p className="text-stone-600 mb-8">
              The advanced app includes deeper rituals, renewal schedules, dashboards, and guided conversations.
            </p>
            <button
              className="bg-mc-blue-deep text-white hover:bg-mc-blue-dark rounded-full px-12 py-4 text-lg font-medium transition-all hover:scale-[1.02] active:scale-[0.98] inline-flex items-center gap-2"
            >
              Coming Soon
              <Sparkles className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePage;
